// external scripts
import $ from 'jquery';
import debug from 'bows';
import fitvids from 'fitvids';
import slug from 'slug';
// import Dropdown from 'modern-dropdown';

// flexible layouts
import Accordion from './layouts/_accordion';
import FeaturedContent from './layouts/_featured-content';
import Portfolio from './layouts/_portfolio';
import Quotes from './layouts/_quotes';
import StateMap from './layouts/_map';
import Tabs from './layouts/_tabs';
import SimpleTabs from './layouts/_simple-tabs';
import ConferenceSpecialEvents from './layouts/_conference-special-events';
import ConferenceTabs from './layouts/_conference-tabs';

// shortcodes
import JobSourceFeed from './shortcodes/_jobsource-feed';
import AdRotate from './shortcodes/_ad-rotate';
import AdStandard from './shortcodes/_ad-standard';

// example of ES2015 modules loading & tree shaking
import { emptyLinks, externalLinks } from './_links';

import breakpoints from './_breakpoints';

const $window = $(window);
const $document = $(document);
const $body = $('body');
// const log       = debug('site');

class Site {
	constructor() {
		this.breakpoints = breakpoints;

		$document.ready(() => this.domReady());
		$window.on('load', () => this.windowLoad());
		$window.on('resize', () => this.windowResize());
		$window.on('scroll', () => this.stickyNav());
	}

	domReady() {
		const log = debug('site:domReady');
		if (typeof $.fn.suggest === 'function') {
			$(".search-form__field").suggest("?method=autocomplete", {});
		}

		this.navigation();
		this.layouts();
		this.shortcodes();
		this.share();
		this.tealium();
		this.cookieNotice();
		this.gTranslate();

		fitvids('#content');

		log('dom.ready');
	}

	windowLoad() {
		const log = debug('site:windowLoad');
		log('window.onload');

		// example of ES2015 modules loading & tree shaking
		emptyLinks();
		externalLinks();
	}

	windowResize() {
		this.stickyNav();
	}

	navigation() {
		this.headers = {
			utility: $('.header__utility'),
			primary: $('.header__primary'),
			tertiary: $('.header__tertiary')
		};

		this.menus = {};
		this.primary();
		this.utility();
		this.tertiary();
		this.footer();
		this.mobileNav();
		this.search();
		this.conference();
		this.stickyNav();
		this.navToTop();
		this.tableMobilizer();
	}

	stickyNav() {
		let log = debug('sticknav');

		const header = document.querySelector('.header');
		if (!header) {
			return;
		}

		const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
		const overflow = document.querySelector('.body-overflow');

		if (!overflow.getAttribute('style')) overflow.style.paddingTop = header.getBoundingClientRect().height + "px";

		if (pageYOffset > 0) {
			document.body.classList.add('header-sticky--small');
		} else {
			document.body.classList.remove('header-sticky--small');
		}
	}

	navToTop() {
		let arrowSvg = '<?xml version="1.0" encoding="utf-8"?>' +
			'<svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">' +
			'<path d="M1395 1184q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23z"/>' +
			'</svg>';
		$('#content').append('<div class="nav--to-top"><a href="#">' + arrowSvg + '<span class="btt-text">Top</span></a></div>');
		$('.nav--to-top').on('click', (e) => {
			e.preventDefault();
			$('html, body').stop().animate({ scrollTop: '0px' }, 500);
		});
	};

	tableMobilizer() {
		const tables = document.querySelectorAll('table[data-responsive="true"]');
		if (tables.length <= 0) return false;

		function buildTable(table, breakPoint, isMobile) {
			if (!isMobile && !table.dataset.mobilized) table.dataset.mobilized = false;

			if (!isMobile && table.dataset.mobilized === 'false') {
				table.dataset.mobilized = true;
				table.dataset.breakpoint = breakPoint;
			} else if (isMobile && table.dataset.mobilized === 'true' && table.dataset.breakpoint <= breakPoint) {
				table.dataset.mobilized = false;
			}
		}

		function runBuild() {
			tables.forEach((el) => {
				const tableWidth = el.getBoundingClientRect().width;
				const windowWidth = (window.innerWidth - 75);

				if (tableWidth >= windowWidth) {
					buildTable(el, tableWidth, false);
				} else {
					buildTable(el, windowWidth, true);
				}
			});
		}

		function setupTables() {
			tables.forEach((el) => {
				const labels = el.querySelectorAll('thead th');
				const rows = el.querySelectorAll('tbody tr');
				const rl = rows.length;

				for (let i = 0; i < rl; i += 1) {
					const items = rows[i].querySelectorAll('td');
					const il = items.length;

					for (let j = 0; j < il; j += 1) {
						const newItem = document.createElement('td');
						newItem.innerHTML = labels[j].innerHTML;
						newItem.className = 'table-mobile-label';
						rows[i].insertBefore(newItem, items[j]);
					}
				}
			});

			window.addEventListener('resize', runBuild);
			runBuild();
		}

		setupTables();
	}

	layouts() {
		this.layoutDict = {
			'featured-content': FeaturedContent,
			accordion: Accordion,
			tabs: Tabs,
			quotes: Quotes,
			map: StateMap,
			portfolio: Portfolio,
			'conference-accordion': Accordion,
			'conference-agenda': SimpleTabs,
			'conference-special-events': ConferenceSpecialEvents,
			'conference-tabs': ConferenceTabs,
		};

		this._layouts = Array.from(document.querySelectorAll('.flex-layout')).map((layout) => {
			return (this.layoutDict[layout.getAttribute('data-layout')]) ? new this.layoutDict[layout.getAttribute('data-layout')](layout) : null;
		}).filter((controller) => typeof controller === 'object');
	}

	primary() {
		this.menus.primary = $('.nav--primary,.nav--secondary');

		this.menus.primary.on('click', '.nav__menu-item--depth0.nav__menu-item--has-submenu > .nav__link', (e) => {
			if ($window.width() < breakpoints.medium) {
				e.preventDefault();
				$(e.currentTarget).parent().toggleClass('nav__link__submenu--open').find('.nav__menu--depth1').slideToggle();
			}
		});

		const itemsDepth0 = Array.from(document.querySelectorAll('.nav--primary .nav__menu-item--depth0'));
		itemsDepth0.forEach((item) => {
			const link = item.querySelector('.nav__link');
			const subMenu = item.querySelector('.nav__menu');

			if (!link || !subMenu) {
				return;
			}

			let labelLi = document.createElement('li');
			labelLi.className = 'nav__menu-item nav__menu-item--depth1 menu-item nav__menu-item__label';
			labelLi.innerHTML = `<a href="${link.href}" class="nav__link"><span>${(link.title) ? link.title : link.querySelector('strong').textContent}</span></a>`;
			subMenu.insertBefore(labelLi, subMenu.firstChild);
		});
	}

	utility() {
		this.menus.utility = $('.nav--utility');
		if (!this.menus.utility.length) {
			return;
		}

		this.menus.utility.append('<i class="nav__utility-triangle"></i>');

		const utilMegaMenus = this.menus.utility.find('.menu-item-object-mega-menu');
		utilMegaMenus.dropdown({
			menu: '.nav__menu-content',
			openClass: 'nav__menu-item--open',
			beforeOpen: () => {
				if (window.innerWidth < breakpoints.medium) {
					return false;
				}
			}
		});

		this.menus.utility.find('.menu-item-object-mega-menu .nav__link').on('click', (e) => {
			if ($window.width() >= breakpoints.medium) {
				return;
			}
			e.preventDefault();
			$(e.currentTarget).parent().toggleClass('nav__menu-item__mega-menu--open').find('.nav__menu-content').slideToggle(200);
		});

		$('.header__utility .menu-item-object-mega-menu .nav__link,.header__utility .menu-item-object-mega-menu .nav__link+.nav__menu-content').hover(() => {
			if ($window.width() > breakpoints.medium) {
				$('.js-header-modal').show();
				$('.header .header__primary').hide();
			}
		}, () => {
			if ($window.width() > breakpoints.medium) {
				$('.js-header-modal').hide();
				$('.header .header__primary').show();
			}
		});
	}

	tertiary() {
		if (this.headers.tertiary.length) {
			let menu = this.headers.primary.find([
				'.nav__menu-item--depth0.current-menu-parent',
				'.nav__menu-item--depth0.current-page-ancestor',
				'.nav__menu-item--depth0.current-menu-item',
				'.nav__menu-item--depth0.current_page_parent'
			].join(', '));

			if (menu.length && menu.find('.nav__menu--depth1 .nav__menu-item--depth1').length > 0) {
				this.headers.tertiary.find('nav').append(menu.find('.nav__menu--depth1').first().clone());
				this.headers.tertiary.addClass('header__tertiary--active');
				this.headers.tertiary.find('.nav__menu-item__label').remove();
			}
		}
	}

	mobileNav() {
		const $hamburger = $('.header__mobile__nav-toggle > a');
		if (!$hamburger.length) {
			return;
		}

		$hamburger.on('click', (e) => {
			e.preventDefault();

			const removeDisplayStyle = function () {
				$(this).css('display', '');
			}

			if ($body.hasClass('mobile-menu--open')) {
				$body.removeClass('mobile-menu--open');
				this.headers.utility.slideToggle(200, () => {
					removeDisplayStyle.call(this.headers.utility.get(0));
					this.headers.primary.slideToggle(200, removeDisplayStyle);
				});
			} else {
				$body.addClass('mobile-menu--open');
				this.headers.primary.slideToggle(200, () => {
					this.headers.utility.slideToggle(200);
				});
			}

		})
	}

	search() {
		const $searchForm = $('.nav.nav--secondary .search-form');
		const $searchControl = $('.search-form .search-form__control');

		$searchControl.on('click', () => {
			$searchForm.toggleClass('search-form--open');
			if ($searchForm.hasClass('search-form--open')) {
				$('.search-form__field input', $searchForm).focus();
			}
		});

		document.addEventListener('keyup', event => {
			if (event.isComposing || event.keyCode === 229) {
				return;
			}

			if (event.keyCode === 27 && $searchForm.hasClass('search-form--open')) {
				$searchForm.removeClass('search-form--open');
			}
		});

	}

	conference() {
		this.headers.conference = $('.header--conference');
		if (this.headers.conference.length === 0) {
			return;
		}

		const $hamburger = this.headers.conference.find('.header__nav-toggle > a');
		const $nav = this.headers.conference.find('.header__nav nav');
		const $open = this.headers.conference.find('.header__nav-toggle--open');
		const $close = this.headers.conference.find('.header__nav-toggle--close');

		$open.on('click', (e) => {
			e.preventDefault();
			$nav.slideDown(200);
			$open.hide();
			$close.show();
		});

		$close.on('click', (e) => {
			e.preventDefault();
			$nav.slideUp(200);
			$close.hide();
			$open.show();
		});
	}

	footer() {
		let $headers = $('.footer__column__title');

		$headers.on('click', (e) => {
			if ($window.width() < breakpoints.medium) {
				let $header = $(e.currentTarget);
				let $column = $header.closest('.footer__column');
				let $nav = $column.find('.nav');

				$nav.slideToggle(400, () => {
					$column.toggleClass('footer__column--open');
					$nav.css('display', '');
				});
			}
		});
	}

	shortcodes() {
		Array.from(document.querySelectorAll('.shortcode__jobsource-feed')).map((node) => {
			return new JobSourceFeed(node);
		});

		Array.from(document.querySelectorAll('.shortcode-ad--image--rotate')).map((node) => {
			return new AdRotate(node);
		});

		Array.from(document.querySelectorAll('.shortcode-ad--standard')).map((node) => {
			return new AdStandard(node);
		});
	}

	share() {
		$(document).on('click', 'a[href="#print"]', (e) => {
			e.preventDefault();
			window.print();
		});
	}

	tealium() {
		$(document).on('mousedown', 'a', (e) => {
			const tlog = debug('site:tealium');
			// bail if utag has been ad-blocked
			if (typeof window.utag === 'object' && typeof window.utag.link === 'function') {
				// find the current link from the event delegation
				const link = $(e.currentTarget);
				// see if any parent nodes have tealium data
				const closestTealium = link.closest('[data-tealium]');
				// list of fields to grab from utag_data from the customer profile
				const profileFields = ['customer_type', 'customer_status', 'customer_id_login', 'customer_id', 'customer_email_address', 'customer_category'];

				// initialize our data object with some defaults
				let data = {
					event_name: 'click',
					event_action: 'click'
				};

				// return if link is part of the WordPress Toolbar
				if (link.parents('#wpadminbar').length > 0) return false;

				//if (link.attr('data-event-category') || link.attr('data-event-action') || link.attr('data-event-label')) return false;

				// slug the text of the link to normalize text differences for the event_label_description
				data.event_label_description = slug((link.attr('data-event-label')) ? link.attr('data-event-label') : (link.attr('title')) ? link.attr('title') : link.text(), { lower: true });

				// if there is no text but an image in the link - use the filename of the image as the event_label_description
				if (!data.event_label_description && link.find('img').length) {
					data.event_label_description = (link.attr('title')) ? link.attr('title') : link.find('img').first().attr('src').split('/').pop();
				}

				// check if click event is pagination and provide readable label
				if (link.hasClass('page-numbers')) {
					if (link.hasClass('next') || link.hasClass('prev')) {
						data.event_label_description = slug('page_' + $('.visually-hidden', link).text(), { lower: true });
					} else {
						data.event_label_description = 'page_' + link.text();
					}
				}

				if (typeof window.utag_data !== 'undefined' && window.utag_data.customer_status && window.utag_data.customer_status !== 'false') {
					// if users are logged in, copy their utag_data values
					profileFields.forEach((key) => {
						if (typeof window.utag_data[key] !== 'undefined') {
							data[key] = window.utag_data[key];
						}
					});
				} else {
					// not logged in
					data.customer_status = '0';
				}

				// if there is tealium data on a post element or layout - grab it and set the value of event_category_campaign
				if (link.attr('data-event-category')) {
					data.event_category_campaign = link.attr('data-event-category');
				} else if (closestTealium.length) {
					data.event_category_campaign = closestTealium.first().attr('data-tealium');
				} else if (window.utag_data.event_category_campaign) {
					data.event_category_campaign = window.utag_data.event_category_campaign;
				}

				// if the event action is defined on the post element - grab it and set the value of event_action
				if (link.attr('data-event-action')) {
					data.event_action = link.attr('data-event-action');
				}

				// if there are any campaigns, change the action to campaign click
				if (data.event_category_campaign && data.event_category_campaign.length > 0 && !link.attr('data-event-action')) {
					data.event_action = 'campaign_click';
				}

				// log the data
				tlog(data);

				window.utag.link(data);
			}
		});
	}

	cookieNotice() {
		const $notice = $('.cookie-notice');
		if (!$notice.length) {
			return;
		}

		$notice.on('click', 'button', () => {
			let expire = new Date();
			expire.setTime(expire.getTime() + (365 * 24 * 60 * 60 * 1000)); // one year-ish
			document.cookie = `wp_cookie_notice_accept=1; path=/; expires=${expire.toGMTString()}`;
			$notice.slideUp(400);
		});
	}

	gTranslate() {
		if ($('.gtranslate_wrapper').length != 1 || $('.menu-item-language').length != 1) return;

		$('.gtranslate_wrapper').appendTo('.menu-item-language');

		if ($('.menu-item-language .gtranslate_wrapper .gt_switcher  .gt_current a').text().toLowerCase().replace(' ', '') === 'english') {
			$('.menu-item-language .gtranslate_wrapper .gt_option a[title="English"]').hide();
			$('.menu-item-language .gtranslate_wrapper .gt_option a[title="Español"]').show();
		} else {
			$('.menu-item-language .gtranslate_wrapper .gt_option a[title="English"]').show();
			$('.menu-item-language .gtranslate_wrapper .gt_option a[title="Español"]').hide();
		}

		$('.menu-item-language .gtranslate_wrapper .gt_option a').on('click', (e) => {
			$('.menu-item-language .gtranslate_wrapper .gt_option a').show();
			$(e.target).hide();
		});

		$('.menu-item-language .gtranslate_wrapper').attr('style', 'display: block !important;');


		return;

		this.runBuild = () => {
			if ($('.menu-item-language .gtranslate_wrapper').length != 1) return setTimeout(() => { this.runBuild(); }, 100);

			$('.menu-item-language .gtranslate_wrapper').show();

			if ($('.menu-item-language .gtranslate_wrapper .gt_switcher  .gt_current a').text().toLowerCase().replace(' ', '') === 'english') {
				$('.menu-item-language .gtranslate_wrapper .gt_option a[title="English"]').hide();
				$('.menu-item-language .gtranslate_wrapper .gt_option a[title="Español"]').show();
			} else {
				$('.menu-item-language .gtranslate_wrapper .gt_option a[title="English"]').show();
				$('.menu-item-language .gtranslate_wrapper .gt_option a[title="Español"]').hide();
			}

			$('.menu-item-language .gtranslate_wrapper .gt_option a').on('click', () => {
				$('.menu-item-language .gtranslate_wrapper .gt_option a').show();
				$(this).hide();
			});
		}

		this.runBuild();
	}

}

export default Site;
